<template>
  <div class="container">
  <ws-list-view
    class="ws-participants__list"
    :data="newParticipants"
    :header="false"
    :bordered="false"
    :striped="false"
    :detailed="false"
    :loading="loadingParticipants"
  >
    <template slot-scope="props">
      <ws-list-view-item-column class="is-block">
        <div
          class="ws-participants__item"
          v-if="props.row.user_info"
        >
          <figure class="ws-participants__item-avatar image is-128x128">
            <a
              :href="`${getProfileLink(props.row.user_info.guid, 'profile', 'user')}`"
              target="_blank"
            >
              <ws-avatar
                v-if="props.row.user_info"
                :id="props.row.user_info.guid"
                :name="`${ props.row.user_info.first.display } ${props.row.user_info.last.display}`"
                sizeType="Small"
                :size="128"
              />
            </a>
          </figure>
          <div class="ws-participants__item-name">
            <a
              class="has-text-black"
              :href="`${getProfileLink(props.row.user_info.guid, 'profile', 'user')}`"
              v-if="props.row.user_info"
              target="_blank"
            >
              {{ props.row.user_info.last.display }} {{ props.row.user_info.first.display }} {{ props.row.user_info.middle.display }}
            </a>
            <span v-if="props.row.user_info !== null && props.row.user_info.profile_stat">
              <b-tooltip
                :label="$t(`Профиль заполнен на ${props.row.user_info.profile_stat.percents}%`)"
                :position="'is-bottom'"
                :type="props.row.user_info.profile_stat.completed ? 'is-success' : 'is-danger'"
                multilined
              >
                <ws-dot-status :type="props.row.user_info.profile_stat.completed ? 'success' : 'danger'" />
              </b-tooltip>
            </span>
          </div>
          <div class="ws-participants__item-email">
            <span
              class="has-text-primary"
              v-if="props.row.user_info"
            >
              <b-tooltip
                position="is-bottom"
                :label="isActive(props.row.all_user_info).msg"
                :type="isActive(props.row.all_user_info).type"
                multilined
              >
                <span
                  class="email-active"
                  v-if="isActive(props.row.all_user_info).active"
                >
                  {{props.row.user_info.email}}
                </span>
                <span
                  v-else
                  class="email-inactive"
                >{{props.row.user_info.email}}</span>
              </b-tooltip>
            </span>
          </div>
          <div class="ws-participants__item-type has-text-right-desktop">
            <span>{{ $t('Участник') }}</span>
          </div>
          <div class="ws-participants__item-info">
              <b-checkbox
                  class="b-checkbox__centered"
                  v-model="props.row.is_retake_exam"
                  @input="onChangeParticipantsRetakeExam(props.row)"
                  :disabled="!isSelected(props.row.guid) || ['front_le', 'front_tech_expert'].includes(currentRole) || !isMyDeCenter"
              >
                Пересдача экзамена
              </b-checkbox>

            <div v-if="showMarks(props.row)">
              <span v-text="$t('Результаты (паспорт компетенций): ')"></span>
              <a
                v-if="!isBlockedStatus || currentRole === 'front_dep' || currentRole === 'front_admin'"
                :href="`${getProfileLink(props.row.guid, 'sp')}`"
                class="tag is-sticker has-text-weight-bold"
                target="_blank"
              >
                <span>{{ getMarkScaled(props.row) || 0 }}/{{ Math.round(Number(current.parent.max_score) * 10)/10 }}</span>
              </a>
              <button
                v-else
                disabled
                class="tag is-sticker has-text-weight-bold tag-disabled"
              >
                <span>{{ getMarkScaled(props.row) || 0 }}/{{ Math.round(Number(current.parent.max_score) * 10)/10 }}</span>
              </button>
              <br>
              <!-- <span
                v-text="$t('WSSS: ')"
                style="display: inline-block; margin-top: 5px; margin-right: 5px;"
              ></span> -->
              <!-- <a
                v-if="!isBlockedStatus || currentRole === 'front_dep' || currentRole === 'front_admin'"
                :href="`${getProfileLink(props.row.guid, 'sp')}`"
                class="tag is-sticker has-text-weight-bold"
                target="_blank"
              >
                <span>{{ props.row.scaled_mark.mark_wsss || 0 }}/{{ Math.round(Number(current.parent.max_wsss_score) * 10)/10 }}</span>
              </a>
              <button
                v-else
                disabled
                class="tag is-sticker has-text-weight-bold tag-disabled"
              >
                <span>{{ props.row.scaled_mark.mark_wsss || 0 }}/{{ Math.round(Number(current.parent.max_wsss_score) * 10)/10 }}</span>
              </button> -->
            </div>
            <ws-exam-groups-participants-details
              v-if="isSelected(props.row.guid)"
              :participant="props.row"
              :exam="exam"
              @updated="updateParticipant"
              @fileUpdated="onParticipantFileUpdated"
            ></ws-exam-groups-participants-details>
          </div>
          <div class="ws-participants__item-status has-text-right-desktop">
            <b
              v-if="props.row.status"
              :class="props.row.status === 'approved' || props.row.status === 'passed' ? 'has-text-success' : 'has-text-grey'"
            >
              {{ $t(`participant.status.${props.row.status}`) }}
            </b>
          </div>
          <div class="ws-participants__item-action">
            <template v-if="currentRole === 'front_rcc' || currentRole === 'front_university' || currentRole === 'front_curator' || currentRole === 'front_curator_institution' || currentRole === 'front_admin'">
              <button
                v-if="isSelected(props.row.guid)"
                class="ws-button button is-danger is-small is-fullwidth"
                @click="removeToParticipantsList(props.row)"
                :disabled="disabled || !isMyDeCenter"
                v-text="$t('Открепить от экз. группы.')"
              ></button>
              <div v-else>
                <popper :options="{placement: 'top'}">
                  <div class="popper is-warning has-text-left exam-status-hint">
                    <ul>
                      <li
                        div
                        v-if="disabledBtnAdd(props.row.all_user_info)"
                        class="has-text-danger"
                      >
                        <ws-icon
                          name="close"
                          color="#EB5757"
                          width="16"
                          height="16"
                        />
                        <span>{{$t('Почта не подтверждена. Участнику направлено письмо с кодом подтверждения.')}}</span>
                      </li>
                      <li
                        v-else
                        class="has-text-success"
                      >
                        <ws-icon
                          name="check-mark"
                          color="#3f842f"
                          width="16"
                          height="16"
                        />
                        <span>{{$t('Почта подтверждена.')}}</span>
                      </li>
                    </ul>
                  </div>
                  <div slot="reference">
                    <button
                      class="ws-button button is-primary is-small is-fullwidth"
                      :class="{inactive : disabledBtnAdd(props.row.all_user_info)}"
                      @click="disabledBtnAdd(props.row.all_user_info) ? null : addToParticipantsList(props.row)"
                      :disabled="disabled || !isMyDeCenter"
                      v-text="$t('Прикрепить к экз. группе')"
                    ></button>
                  </div>
                </popper>
              </div>
            </template>
            <template v-if="(currentRole === 'front_me' || currentRole === 'front_mc') && props.row.status && props.row.status ==='registered'">
              <button
                class="ws-button button is-warning is-small has-text-white is-fullwidth"
                :disabled="disabled || !isMyDeCenter"
                @click="updateParticipantStatus(props.row, 'approved')"
                v-text="$t('Подтвердить присутствие в день ПД')"
              ></button>
            </template>
            <template v-if="(currentRole === 'front_me' || currentRole === 'front_mc') && props.row.status && props.row.status ==='approved' && exam.status !=='approved_main_expert'">
              <button
                class="ws-button button is-light is-small is-fullwidth"
                :disabled="disabled || !isMyDeCenter"
                @click="updateParticipantStatus(props.row, 'registered')"
                v-text="$t('Отменить присутствие')"
              ></button>
            </template>
            <template v-if="(currentRole === 'front_me' || currentRole === 'front_mc') && props.row.status && props.row.status ==='approved' && exam.status ==='approved_main_expert'">
              <button
                class="ws-button button is-warning has-text-white is-small is-fullwidth"
                :disabled="disabled || !isMyDeCenter"
                @click="updateParticipantStatus(props.row, 'passed')"
                v-text="$t('Подтвердить присутствие и завершить выполнение задания')"
              ></button>
            </template>
            <template v-if="(currentRole === 'front_me' || currentRole === 'front_mc') && props.row.status && props.row.status ==='passed' && exam.status ==='approved_main_expert'">
              <button
                class="ws-button button is-light is-small is-fullwidth"
                :disabled="disabled || !isMyDeCenter"
                @click="updateParticipantStatus(props.row, 'approved')"
                v-text="$t('Отменить присутствие участника на экзамене')"
              ></button>
            </template>
            <template v-if="currentRole === 'front_50plus' || currentRole === 'front_mio'">
              <button
                class="ws-button button is-danger is-small is-fullwidth"
                :disabled="disabled || !isMyDeCenter"
                @click="removeFormParticipantsList(props.row)"
                v-text="$t('Удалить')"
              ></button>
            </template>
          </div>
        </div>
      </ws-list-view-item-column>
    </template>
    <template slot="skeleton">
      <ws-list-view-skeleton-item
        :height="'107px'"
        :boxCount="1"
        :boxHeights="['105px']"
      />
      <ws-list-view-skeleton-item
        :height="'107px'"
        :boxCount="1"
        :boxHeights="['105px']"
      />
    </template>
    <template slot="empty">
      <ws-role-node :only="['front_rcc', 'front_university', 'front_dep', 'front_admin']">
        <router-link
          v-if="current.education_group && current.education_group.university !== null"
          class="ws-button button"
          :to="`/orgs/${current.education_group.university.guid}/groups`"
        >
          <span
            class="ws-button__text"
            v-text="$t('Добавить участников в учебную группу')"
          ></span>
        </router-link>
      </ws-role-node>
        <p>Участники не добавлены</p>
    </template>
  </ws-list-view>
    <b-loading
      :active="loadingParticipants"
      :is-full-page="false"
      :can-cancel="false"
    ></b-loading>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Popper from 'vue-popperjs'
import WsExamGroupsParticipantsDetails from '@/components/de/demo-exams/WsExamGroupsParticipantsDetails'
import WsDotStatus from '@/components/common/WsDotStatus'
import axios from 'axios'
import isBlockedExam from '@/mixins/is-blocked-exam.mixin'
import { debounce } from 'debounce'

export default {
  name: 'WsExamGroupsParticipantsList',
  components: {
    WsDotStatus,
    WsExamGroupsParticipantsDetails,
    Popper
  },
  mixins: [isBlockedExam],
  props: {
    guid: {
      type: String
    },
    selectedItems: {
      type: Array,
      default () {
        return []
      }
    },
    exam: {
      type: Object
    },
    current: {
      type: Object,
      default () {
        return {}
      }
    },
    isMyDeCenter: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    groups: {
      type: Array,
      default () {
        return []
      }
    },
    disabled: Boolean
  },
  data () {
    return {
      newItems: [],
      newSelectedItems: [],
      newParticipants: [],
      loadingParticipants: false
    }
  },
  watch: {
    items: {
      deep: true,
      immediate: true,
      handler (items) {
        if (items && Array.isArray(items)) {
          this.newItems = items
          if (this.currentRole === 'front_me' || this.currentRole === 'front_mc') {
            this.newItems = this.items.filter(item => item.status === 'registered' || item.status === 'approved' || item.status === 'passed')
          }
        }
      }
    },
    currentRole: {
      handler (role) {
        this.newItems = role === 'front_me' || role === 'front_mc' ? this.items.filter(item => item.status === 'registered' || item.status === 'approved' || item.status === 'passed') : this.items
      }
    },
    selectedItems: {
      deep: true,
      immediate: true,
      handler (items) {
        if (items && Array.isArray(items)) {
          this.newSelectedItems = items
        }
      }
    },
    participants () {
      this.getParticipants()
    }
  },
  computed: {
    ...mapState('authentication', {
      currentRole: 'currentRole'
    }),
    participants () {
      let _items = []
      if (this.newItems && Array.isArray(this.newItems)) {
        _items = this.newItems
          .filter(item => { return item && item && item.user_info })
          .reduce((x, y) => x.findIndex(e => e.user_info.email === y.user_info.email) < 0 ? [...x, y] : x, [])
          .sort((a, b) => {
            const userA = `${a.user_info ? a.user_info.last.display : ''} ${a.user_info.first.display} ${a.user_info.middle.display}`
            const userB = `${b.user_info.last.display} ${b.user_info.first.display} ${b.user_info.middle.display}`
            return userA > userB ? 1
              : userA === userB ? (userA > userB ? 1 : -1) : -1
          })
      }
      return _items
    },
    isNoc () {
      return this.exam.flags.indexOf('independent_estimate') > -1
    },
    participantsIds () {
      if (this.newItems && Array.isArray(this.newItems)) {
        return this.newItems.map(p => p.user_info === null ? p.guid : p.user_info.guid)
      } else {
        return []
      }
    }
  },
  mounted () {
    this.getParticipants()
  },
  methods: {
    async getParticipants () {
      this.loadingParticipants = true
      if (this.participantsIds && this.participantsIds.length) {
        try {
          const res = await axios.post(`${__config.api_url}/api/auth/users-list`, {
            'guid': this.participantsIds
          })
          const newParticipants = this.participants
          if (res.data.data && Array.isArray(res.data.data) && Array.isArray(newParticipants)) {
            res.data.data.forEach(p => {
              newParticipants.forEach(np => {
                if (np.user_info && p.guid === np.user_info.guid) {
                  np.all_user_info = p
                }
              })
            })
          }
          this.newParticipants = newParticipants
        } catch (err) {
          this.newParticipants = this.participants
        }
      } else {
        this.newParticipants = this.participants
      }
      this.loadingParticipants = false
    },
    disabledBtnAdd (info) {
      if (info && info.activation_status) return false

      if (this.disabled) {
        return true
      } else if (info.activation_status === 'active' || info.activation_status === 'active_without_confirm') {
        return false
      } else {
        return true
      }
    },
    isActive (info) {
      if (info === null) {
        return {
          msg: this.$t('Пользователь не найден.'),
          type: 'is-success',
          active: true
        }
      }

      if (info && info.activation_status && (info.activation_status === 'active' || info.activation_status === 'active_without_confirm')) {
        return {
          msg: this.$t('Почта подтверждена.'),
          type: 'is-success',
          active: true
        }
      }

      return {
        msg: this.$t(`Почта не подтверждена.\nУчастнику направлено письмо с кодом подтверждения.`),
        type: 'is-danger',
        active: false
      }
    },
    getPassportId (competencyCode, passportId) {
      return `${competencyCode}_${'0'.repeat(13 - passportId.toString().length)}${passportId}dp`
    },
    getProfileLink (guid, service, segment = null) {
      return `${__config.services[service]}/${segment ? `${segment}/` : ''}${guid}/`
    },
    showMarks (user) {
      const scaledMarkDate = user.scaled_mark && user.scaled_mark.imported_at && new Date(user.scaled_mark.imported_at)

      return scaledMarkDate && scaledMarkDate.getFullYear() !== 0 && user.status === 'passed'
    },
    getMarkScaled (user) {
      return user.scaled_mark && this.showMarks(user) ? user.scaled_mark.mark100 : 0
    },
    isSelected (guid) {
      return this.newSelectedItems.find(item => item.guid === guid)
    },
    onChangeParticipantsRetakeExam: debounce(function (item) {
      this.$emit('onChangeParticipantsRetakeExam', item)
    }, 1000),
    addToParticipantsList (item) {
      const canAdd = this.canAddInGroup(item)
      if (canAdd !== undefined) {
        this.$buefy.dialog.confirm({
          title: this.$t(`Участник уже добавлен в другую экзаменационную группу этого демонстрационного экзамена.`),
          message: this.$t(` Вы уверены, что хотите прикрепить участника одновременно к двум разным экзаменационным группам одного демонстрационного экзамена?`),
          cancelText: this.$t('Отмена'),
          confirmText: this.$t('Прикрепить'),
          type: 'is-danger',
          onConfirm: async () => {
            this.newSelectedItems = [...this.newSelectedItems, item]
            this.$emit('input-users', { action: 'update', users: [item] })
          }
        })
      } else {
        this.newSelectedItems = [...this.newSelectedItems, item]
        this.$emit('input-users', { action: 'update', users: [item] })
      }
    },
    canAddInGroup (participant) {
      const participants = this.groups.filter((item) => item.guid !== this.current.guid).map(item => item.participants).flat()
      return participants.find(part => part && part.user_info && part.user_info.guid === participant.user_info.guid)
    },
    removeFormParticipantsList (item) {
      this.$emit('input-users', { action: 'delete', users: [item] })
    },
    updateParticipantStatus (user, status) {
      this.$emit('input-users', { action: 'update-status', user, status })
    },
    removeToParticipantsList (item) {
      this.$buefy.dialog.confirm({
        title: this.$t(`Вы действительно хотите удалить участника из списка?`),
        cancelText: this.$t('Отмена'),
        confirmText: this.$t('Убрать'),
        type: 'is-danger',
        onConfirm: async () => {
          this.newSelectedItems = this.newSelectedItems.filter(user => user.user_info.guid !== item.user_info.guid)
          this.$emit('input-users', { action: 'delete', users: [item] })
        }
      })
    },
    onParticipantFileUpdated (item) {
      this.$emit('input-users', { action: 'update-participant-file', user: item })
    },
    updateParticipant (item) {
      this.$emit('input-users', { action: 'update-participant', user: item })
    }
  }
}
</script>

<style scoped>
.container{
  position: relative;
}

.ws-participants__item-email {
  cursor: pointer;
}

.ws-participants__item-email .email-inactive {
  color: #eb5757;
}
.ws-participants__item-email .email-active {
  color: #3f842f;
}
.ws-participants__list {
  overflow-x: visible;
  overflow-y: visible;
}

.inactive {
  cursor: not-allowed;
  opacity: 0.6;
}
.tag-disabled {
  border: none;
  opacity: 0.5;
}

.b-tooltip.is-bottom.is-multiline.is-medium:after {
  width: auto;
}
</style>
